module.exports = __webpack_public_path__ + "img/h6.07ac57d9.png";